// extracted by mini-css-extract-plugin
module.exports =  {"STORY_FLOW_OFFSET_TOP":"40px","flow":"flow--cP6ux","root":"root--GTsQQ"};